import {ICalEvent} from "../domain/dtos/i-cal-event.dto";

export class ProjectHelper {

    public static getTitle(iCalEvent: ICalEvent): string {
        let [title] = iCalEvent.summary.split(':').map(v => v.trim());
        let pos = title.trim().lastIndexOf(' ');
        if (pos < 0) {
            pos = title.length;
        }

        return title.substring(0, pos).replace(/\W{2,}/g, ' ').trim();
    }

    public static hasSomeEndInFuture(): boolean {
        return false;
    }
}